<template>
  <div class="content-tag-select" :class="{ 'is-disabled': disabled }">
    <button
      v-for="tag in tags"
      :key="tag.tagId"
      type="button"
      class="tag-chip"
      :class="{ active: isSelected(tag.tagId) }"
      :style="chipStyle(tag)"
      :disabled="disabled"
      :title="isSelected(tag.tagId) ? '点击取消' : '点击选中'"
      @click="toggle(tag.tagId)"
    >
      {{ tag.name }}
    </button>
    <span v-if="loading" class="hint">加载标签…</span>
    <span v-else-if="!tags.length" class="hint">{{ placeholder || '暂无标签' }}</span>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContentTagSelect',
  props: {
    modelValue: { type: Array, default: () => [] },
    scope: { type: String, required: true },
    placeholder: { type: String, default: '请选择标签（可多选）' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      loading: false,
      tags: []
    }
  },
  computed: {
    normalized() {
      return (this.modelValue || []).map((id) => Number(id)).filter((id) => id > 0)
    }
  },
  watch: {
    scope: {
      immediate: true,
      handler() {
        this.loadTags()
      }
    }
  },
  methods: {
    isSelected(tagId) {
      return this.normalized.includes(Number(tagId))
    },
    chipStyle(tag) {
      if (!tag?.color) return {}
      if (this.isSelected(tag.tagId)) {
        return { background: tag.color, borderColor: tag.color, color: '#fff' }
      }
      return { borderColor: tag.color, color: tag.color }
    },
    toggle(tagId) {
      if (this.disabled) return
      const id = Number(tagId)
      const next = this.isSelected(id)
        ? this.normalized.filter((n) => n !== id)
        : [...this.normalized, id]
      this.$emit('update:modelValue', next)
    },
    async loadTags() {
      if (!this.scope) {
        this.tags = []
        return
      }
      this.loading = true
      try {
        const response = await axios.post('/api/v1/content/tag/list', {
          scope: this.scope,
          recommendedOnly: 0
        })
        if (response.data?.code === 200) {
          this.tags = response.data.data?.tags || []
        } else {
          this.tags = []
        }
      } catch {
        this.tags = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.content-tag-select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 28px;
}

.content-tag-select.is-disabled {
  opacity: 0.65;
}

.tag-chip {
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
  font-family: inherit;
}

.tag-chip:hover:not(:disabled) {
  border-color: #409eff;
  color: #409eff;
}

.tag-chip.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.tag-chip:disabled {
  cursor: not-allowed;
}

.hint {
  font-size: 12px;
  color: #909399;
}
</style>
